import { jsx as _jsx, Fragment as _Fragment } from "react/jsx-runtime";
import { useCallback } from 'react';
import { useFetch } from '@rad/hooks';
import { fetchPropertyEventsPage, getPropertyEventFilters } from '../../../common/network/event-store';
import EventActivity from './event-activity';
// The change history of one property, read-only.
const PropertyActivity = (props) => {
    const [filtersPromise] = useFetch(getPropertyEventFilters(props.propertyId));
    const fetchPage = useCallback((search, eventTypes, userIds, dateFrom, dateTo) => { var _a; return fetchPropertyEventsPage((_a = props.propertyId) !== null && _a !== void 0 ? _a : '', search, eventTypes, userIds, dateFrom, dateTo); }, [props.propertyId]);
    if (!props.propertyId)
        return null;
    return _jsx(_Fragment, { children: _jsx(EventActivity, { fetchPage: fetchPage, filtersPromise: filtersPromise, showUserFilter: true }) });
};
export default PropertyActivity;
